import {Component} from '@angular/core';
import {FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {FormService} from "../../../components/service/form.service";
import {NewsletterService} from "../../../newsletter/service/newsletter.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {tap} from "rxjs";
import {NotificationComponent} from "../../../notifications/notification/component";
import {TranslocoService} from "@ngneat/transloco";

@Component({
  templateUrl: './subscribe.html'
})
export class WebshopNewsletterSubscribeComponent {
  group: FormGroup;
  emailControl: FormControl;
  firstNameControl: FormControl;
  lastNameControl: FormControl;

  constructor(
    private formService: FormService,
    private newsletterService: NewsletterService,
    private snackBar: MatSnackBar,
    private translationService: TranslocoService,
    fb: FormBuilder
  ) {
    this.group = fb.group({});
    this.emailControl = fb.control('', formService.bindValidations(formService.getValidations(['required', 'email'])));
    this.firstNameControl = fb.control('', formService.bindValidations(formService.getValidations(['required'])));
    this.lastNameControl = fb.control('', formService.bindValidations(formService.getValidations(['required'])));

    this.group.addControl('email', this.emailControl);
    this.group.addControl('firstName', this.firstNameControl);
    this.group.addControl('lastName', this.lastNameControl);
  }

  subscribeNewsletter() {
    if (this.group.valid) {
      this.newsletterService.subscribe$(this.firstNameControl.value, this.lastNameControl.value, this.emailControl.value).pipe(
        tap(() => {
          const snackBarRef = this.snackBar.openFromComponent(NotificationComponent);
          snackBarRef.instance.class = 'success';
          snackBarRef.instance.message$ = this.translationService.selectTranslate('notification.subscribed');
        })
      ).subscribe();
    } else {
      this.formService.validateAllFormFields(this.group);
    }
  }
}
